module.exports = __webpack_public_path__ + "media/images/front/pc/default/noimage_s60x60-f53b682115bf897c6a129676de6f5fa6.png";